<template>
  <Content nav="true" admin="true">
    <h1>Orders</h1>
    <table class="pure-table pure-table-horizontal crud">
      <thead>
        <tr>
          <th>Status</th>
          <th>Order ID</th>
          <th>Submitted</th>
          <th>Email</th>
          <th>Event Date</th>
          <th>
            <form class="pure-form">
              <input
                v-model="searchQuery"
                type="search"
                class="pure-input-rounded"
                placeholder="Search"
              >
            </form>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="order in searchResults" :key="order.id">
          <td>
            <span :class="order.data().status">{{ order.data().status }}</span>
          </td>
          <td>{{ order.id }}</td>
          <td>{{ order.data().submittedDate | moment }}</td>
          <td>{{ order.data().contactInfo.email }}</td>
          <td>{{ order.data().eventInfo.date | moment | invalidDate }}</td>
          <td>
            <div class="pure-button-group">
              <button
                @click.prevent="edit(order.id)"
                class="pure-button button-xsmall button-secondary"
              >
                <font-awesome-icon icon="edit"/>
              </button>
              <button
                @click.prevent="remove(order.id)"
                class="pure-button button-xsmall button-error"
              >
                <font-awesome-icon icon="trash-alt"/>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </Content>
</template>

<script>
import Session from '@/mixins/Session.js'
import Moment from 'moment'

export default {
  name: 'Orders',
  mixins: [Session],
  beforeMount() {
    this.authorize()
  },
  data() {
    return {
      searchQuery: '',
      orders: []
    }
  },
  filters: {
    moment: function(date) {
      return Moment(date).format('MMM D, YYYY')
    },
    invalidDate: function(date) {
      if (date === 'Invalid date') {
        return ''
      } else {
        return date
      }
    }
  },
  computed: {
    searchResults() {
      if (this.searchQuery === '') {
        return this.orders
      } else {
        return this.orders.filter(order =>
          order.id.toLowerCase().includes(this.searchQuery.toLowerCase())
        )
      }
    }
  },
  methods: {
    get() {
      this.$database
        .collection('orders')
        .get()
        .then(collection => (this.orders = collection.docs))
    },
    edit(id) {
      this.$router.push({ name: 'order', params: { id: id } })
    },
    remove(id) {
      if (confirm(`Remove order ${id}?`)) {
        this.$database
          .collection('orders')
          .doc(id)
          .delete()
        this.get()
      }
    }
  },
  mounted() {
    this.get()
  }
}
</script>

<style lang="less" scoped>
.pending,
.hold,
.started,
.complete {
  color: white;
  padding: 3px;
  font-size: 0.85em;
  border-radius: 3px;
  font-weight: bold;
  text-transform: uppercase;
}

.pending {
  background: rgb(202, 60, 60);
}

.hold {
  background: rgb(223, 117, 20);
}

.started {
  background: rgb(28, 184, 65);
}

.complete {
  background: rgb(66, 184, 221);
}
</style>
